import { Text, View, StyleSheet } from "@react-pdf/renderer";
import {
  formatNumber,
  getIncrementosDeduccionesCalculados,
  toNumber,
} from "../../../services/mappings";

const styles = StyleSheet.create({
  table: {
    marginTop: 6,
    fontSize: 8,
  },
  row: {
    flexDirection: "row",
  },
  cell: {
    border: "1px solid #000",
    paddingVertical: 3,
    paddingHorizontal: 3,
    justifyContent: "center",
  },
  headerCell: {
    paddingVertical: 5,
  },
  bold: {
    fontWeight: "bold",
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },

  wMrT: { width: "26%" },
  wDesc: { width: "46%" },
  wAma: { width: "15%" },
  wMb: { width: "10%" },
  wMr: { width: "10%" },
  wMt: { width: "6%", fontSize: 6 },
  wAf: { width: "13%" },

  bg: {
    backgroundColor: "#f0f0f0",
  },
  noBorder: {
    border: "0pt solid #000",
  },
});

function NetTotal({ detalles, incrementos, totals }) {
  const detallesData = detalles?.data ?? [];
  const totalDetalle =
    detallesData.find(
      (d) => d?.roW_TYPE === 1 && d?.listadO_PARTIDA_CODIGO === "^",
    ) ??
    detallesData[0] ??
    {};

  const { subAma, subPa } = getIncrementosDeduccionesCalculados(
    detalles,
    incrementos,
  );

  const acumuladoMesAnterior =
    totals?.ama ?? toNumber(totalDetalle?.acuM_ANTERIOR_MONTO_PAGO_MC) + subAma;

  const montoMonedaBase =
    totals?.mb ?? toNumber(totalDetalle?.eP_MES_MONTO_BASE_MC);
  const montoReajuste =
    totals?.mr ?? toNumber(totalDetalle?.eP_MES_REAJUSTE_MC);

  const montoTotal =
    totals?.mt ?? toNumber(totalDetalle?.eP_MES_MONTO_PAGO_MC) + subPa;

  const acumuladoALaFecha = totals?.af ?? acumuladoMesAnterior + montoTotal;

  return (
    <View style={styles.table} wrap={false}>
      {/* Header fila 1 */}
      <View style={styles.row}>
        <View
          style={[
            styles.cell,
            styles.wDesc,
            styles.headerCell,
            styles.noBorder,
          ]}
        />
        <View
          style={[styles.cell, styles.wAma, styles.headerCell, styles.noBorder]}
        />

        <View
          style={[
            styles.cell,
            styles.wMrT,
            styles.headerCell,
            { backgroundColor: "#d0d0d0" },
          ]}
        >
          <Text style={[styles.bold, styles.center]}>
            MONTO ESTADO DE PAGO ACTUAL
          </Text>
        </View>
        <View
          style={[styles.cell, styles.wAf, styles.headerCell, styles.noBorder]}
        />
      </View>

      {/* Header fila 2 */}
      <View style={styles.row}>
        <View
          style={[
            styles.cell,
            styles.wDesc,
            styles.headerCell,
            styles.noBorder,
          ]}
        />
        <View
          style={[
            styles.cell,
            styles.wAma,
            styles.headerCell,
            { backgroundColor: "#d0d0d0" },
          ]}
        >
          <Text
            style={[styles.bold, styles.center]}
            hyphenationCallback={(word) => [word]}
          >
            ACUMULADO MES ANTERIOR
          </Text>
        </View>
        <View
          style={[
            styles.cell,
            styles.wMb,
            styles.headerCell,
            { backgroundColor: "#d0d0d0" },
          ]}
        >
          <Text
            style={[styles.bold, styles.center]}
            hyphenationCallback={(word) => [word]}
          >
            MONTO MONEDA BASE
          </Text>
        </View>
        <View
          style={[
            styles.cell,
            styles.wMr,
            styles.headerCell,
            { backgroundColor: "#d0d0d0" },
          ]}
        >
          <Text
            style={[styles.bold, styles.center]}
            hyphenationCallback={(word) => [word]}
          >
            MONTO REAJUSTE
          </Text>
        </View>
        <View
          style={[
            styles.cell,
            styles.wMt,
            styles.headerCell,
            { backgroundColor: "#d0d0d0" },
          ]}
        >
          <Text
            style={[styles.bold, styles.center, { fontSize: 8 }]}
            hyphenationCallback={(word) => [word]}
          >
            MONTO TOTAL
          </Text>
        </View>
        <View
          style={[
            styles.cell,
            styles.wAf,
            styles.headerCell,
            { backgroundColor: "#d0d0d0" },
          ]}
        >
          <Text
            style={[styles.bold, styles.center]}
            hyphenationCallback={(word) => [word]}
          >
            ACUMULADO A LA FECHA
          </Text>
        </View>
      </View>

      {/* Data */}
      <View style={[styles.row, styles.bg]}>
        <View style={[styles.cell, styles.wDesc]}>
          <Text style={styles.bold}>TOTAL NETO ESTADO DE PAGO</Text>
        </View>
        <View style={[styles.cell, styles.wAma]}>
          <Text style={[styles.bold, styles.right]}>
            {formatNumber(acumuladoMesAnterior, 0, 0)}
          </Text>
        </View>
        <View style={[styles.cell, styles.wMb]}>
          <Text style={[styles.bold, styles.right]}>
            {formatNumber(montoMonedaBase, 0, 0)}
          </Text>
        </View>
        <View style={[styles.cell, styles.wMr]}>
          <Text style={[styles.bold, styles.right]}>
            {formatNumber(montoReajuste, 0, 0)}
          </Text>
        </View>
        <View style={[styles.cell, styles.wMt]}>
          <Text style={[styles.bold, styles.right]}>
            {formatNumber(montoTotal, 0, 0)}
          </Text>
        </View>
        <View style={[styles.cell, styles.wAf]}>
          <Text style={[styles.bold, styles.right]}>
            {formatNumber(acumuladoALaFecha, 0, 0)}
          </Text>
        </View>
      </View>
    </View>
  );
}

export default NetTotal;
